var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5724 4C41.0219 4.7 39.3506 5.16 37.6189 5.38C39.3909 4.32 40.7601 2.64 41.4045 0.62C39.7332 1.62 37.8807 2.32 35.9275 2.72C34.3367 1 32.1016 0 29.5645 0C24.8325 0 20.9664 3.84 20.9664 8.58C20.9664 9.26 21.0469 9.92 21.1879 10.54C14.0195 10.18 7.63632 6.76 3.38762 1.58C2.64258 2.84 2.21973 4.32 2.21973 5.88C2.21973 8.86 3.72993 11.5 6.06571 13C4.63605 13 3.30707 12.6 2.13918 12C2.13918 12 2.13918 12 2.13918 12.06C2.13918 16.22 5.11932 19.7 9.06599 20.48C8.34109 20.68 7.57592 20.78 6.79061 20.78C6.24694 20.78 5.70326 20.72 5.17973 20.62C6.26707 24 9.42843 26.52 13.2341 26.58C10.2943 28.9 6.56911 30.26 2.50163 30.26C1.81701 30.26 1.13238 30.22 0.447754 30.14C4.2736 32.58 8.82435 34 13.6973 34C29.5645 34 38.2834 20.92 38.2834 9.58C38.2834 9.2 38.2834 8.84 38.2633 8.46C39.9547 7.26 41.4045 5.74 42.5724 4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4d4080b2a067d9304bb416ee0aa57664.svg";
export { ForwardRef as ReactComponent };